var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("h5", [_vm._v("Pengumuman")]),
      _vm._v(" "),
      _vm._l(_vm.pengumuman, function (data, index) {
        return _c(
          "div",
          { key: index, staticClass: "accordion", attrs: { role: "tablist" } },
          [
            _c(
              "b-alert",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: "accordion-" + index,
                    expression: "'accordion-' + index",
                  },
                ],
                staticClass: "p-2 mb-1",
                attrs: { show: "", variant: "info" },
              },
              [_vm._v(_vm._s(data.PengumumanJudul))]
            ),
            _vm._v(" "),
            _c(
              "b-collapse",
              {
                attrs: {
                  id: "accordion-" + index,
                  visible: index == 0 ? true : false,
                  accordion: "my-accordion",
                  role: "tabpanel",
                },
              },
              [
                _c(
                  "b-card-body",
                  [_c("b-card-text", [_vm._v(_vm._s(data.PengumumanIsi))])],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }